import { UserOrganizationEducationalContent } from '../../../../types/user'

export enum ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES {
	GET = 'ORG_SETTINGS_GET_ORGANIZATION_DETAILS',
}
export interface OrganizationDetails {
	_id?: string
	educationalContent: Array<UserOrganizationEducationalContent>
}
export interface OrgSettingsGetOrganizationDetails {
	type: ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES.GET
	payload: OrganizationDetails
}

export type OrgSettingsOrganizationDetailsActions =
	OrgSettingsGetOrganizationDetails
